import { Builder } from '@builder.io/react'
import React from 'react'

import { HeadingClass, HeadingType } from 'enums'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}
interface Member {
  memberName: string
  memberDesignation: string
  memberDesc: string
  memberImage: any
  memberImgAltText: string
}

interface Props {
  backgroundColor: string
  headingText: string
  headingTextColor: string
  memberNameTextColor: string
  memberDesignationTextColor: string
  memberDescTextColor: string
  members: Member[]
  headingType: HeadingType
  headingClass: HeadingClass
  textAlignment: Alignment
}

const Teams = ({
  backgroundColor,
  headingText,
  headingTextColor,
  memberNameTextColor,
  memberDesignationTextColor,
  memberDescTextColor,
  members,
  headingType,
  headingClass,
  textAlignment
}: Props) => {
  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const textAlignClass = getAlignmentClass()

  return (
    <div className="bg-white" style={{ backgroundColor }}>
      <div className="mx-auto max-w-7xl py-5 px-4 sm:px-6 lg:px-8 lg:py-10">
        <div className="space-y-12">
          <div className={`${textAlignClass}`}>
            <CustomHeading
              classList={`tracking-tight`}
              headingClass={headingClass}
              headingType={headingType}
              color={headingTextColor}
            >
              {headingText}
            </CustomHeading>
          </div>

          <ul
            role="list"
            className="space-y-12 lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8 lg:gap-y-12 lg:space-y-0"
          >
            {members?.map((member, i) => (
              <li key={i}>
                <div className="mb-4 space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                  <div className="aspect-w-3 aspect-h-3 h-0 sm:aspect-w-3 sm:aspect-h-4">
                    <img
                      className="object-cover object-top shadow-lg"
                      src={
                        member.memberImage ||
                        'https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80'
                      }
                      alt={member.memberImgAltText}
                    />
                  </div>
                  <div className="sm:col-span-2">
                    <div className="space-y-4">
                      <div className="space-y-1 text-lg font-medium leading-6">
                        <h3 style={{ color: memberNameTextColor }}>{member.memberName}</h3>
                        <p className="text-indigo-600" style={{ color: memberDesignationTextColor }}>
                          {member.memberDesignation}
                        </p>
                      </div>
                      <div className="text-base">
                        <p className="text-gray-500" style={{ color: memberDescTextColor }}>
                          {member.memberDesc}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Teams

Builder.registerComponent(Teams, {
  name: 'Teams',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Meet our leadership'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'memberNameTextColor',
      type: 'color',
      defaultValue: 'purple'
    },
    {
      name: 'memberDesignationTextColor',
      type: 'color',
      defaultValue: 'red'
    },
    {
      name: 'memberDescTextColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'members',
      type: 'list',
      defaultValue: [
        {
          memberName: 'Leonard Krasner',
          memberDesignation: 'Senior Designer',
          memberDesc: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis',
          memberImage: null,
          memberImgAltText: ''
        }
      ],
      subFields: [
        { name: 'memberName', type: 'text', defaultValue: 'Leonard Krasner' },
        { name: 'memberDesignation', type: 'text', defaultValue: 'Senior Designer' },
        {
          name: 'memberDesc',
          type: 'text',
          defaultValue: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis'
        },
        { name: 'memberImage', type: 'file', defaultValue: null },
        { name: 'memberImgAltText', type: 'text', defaultValue: '' }
      ]
    }
  ]
})
